/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTaggedSuggestions.defs'
export { main as default } from './getTaggedSuggestions.defs'
